module.exports = __webpack_public_path__ + "img/shop10de.541370fc.png";